import { z } from 'zod';

const serviceSchema = z
  .object(
    {
      name: z.string(),
      price: z.coerce.number(),
      id: z.string(),
      reservationPct: z.coerce.number(),
      maxConsumers: z.coerce.number(),
      minConsumers: z.coerce.number(),
      minAge: z.coerce.number(),
      maxAge: z.coerce.number(),
      code: z.string().nullable(),
      serviceDivisionGroups: z.any(),
    },
    { required_error: 'schemas.chooseService.serviceRequired' }
  )
  .superRefine((obj, ctx) => {
    if (!(obj.name && obj.price !== undefined && obj.id)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'schemas.chooseService.messageError'
      });
    }
  });

const formChooseServiceSchema = (dynamicValidations: {
  minParticipants: number;
  maxParticipants: number;
}) => {
  return z
    .object({
      service: serviceSchema,
      participants: z.coerce.number()
    })
    .superRefine((data, ctx) => {
      const { minParticipants, maxParticipants } = dynamicValidations;
      const participants = data.participants;

      if (participants < minParticipants) {
        ctx.addIssue({
          path: ['participants'],
          code: z.ZodIssueCode.custom,
          message: `schemas.chooseService.participantsMin|{"minParticipants": ${minParticipants}}`
        });
        return;
      }

      if (participants > maxParticipants) {
        ctx.addIssue({
          path: ['participants'],
          code: z.ZodIssueCode.custom,
          message: `schemas.chooseService.participantsMax|{"maxParticipants": ${maxParticipants}}`
        });
      }
    });
};

export default formChooseServiceSchema;
